export function formatValueHuman(d) {
    if (d == null)
        return "";
    return d;
}
